<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini" ref="form">
            <el-form-item label="文件名：" class="query-form-item">
                <el-input v-model="query.filename" placeholder="请输入文件名"></el-input>
            </el-form-item>
            <el-form-item label="备注：" class="query-form-item">
                <el-input v-model="query.remark" placeholder="请输入备注"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
                <el-button type="primary" @click.native="uploadFunc(null,null)">上传</el-button>
                <el-button v-show="showAsinSupervisor" type="success" @click.native="personInCharge()">负责人</el-button>
            </el-form-item>
        </el-form>
        <el-table
            :height="tableHeight"
            v-loading="loading"
            :data="list"
            stripe border style="width: 100%">
            <el-table-column prop="id" label="ID" width="100" align="center">
            </el-table-column>
            <el-table-column prop="add_time" label="上传时间" align="center" width="170">
            </el-table-column>

            <el-table-column
                label="源文件名" align="center"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.filename }}</span>
                </template>
            </el-table-column>

            <el-table-column
                label="备注" align="center"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>

            <el-table-column
                label="操作"
                align="center"
                fixed="right"
                width="220">
                <template slot-scope="scope">
                    <el-button v-show="scope.row.source_path" type="primary" size="mini"
                               @click="downFile(scope.row.source_path)">下载
                    </el-button>
                    <el-button type="success" size="mini" @click.native="handleDetail(scope.$index, scope.row)">详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>


        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>


        <!--        上传-->
        <uploadInfo :visible="addSubLibraryModal" @close-callback="closeCllback" title="上传货件物流"></uploadInfo>
        <!--        详情-->
        <shipmentDetail @close-callback="closeCllback" ref="shipmentDetailRef"></shipmentDetail>

        <personInChargeModal ref="personInChargeModal" @refreshPage="closeCllback"></personInChargeModal>

    </div>

</template>

<script>
    import {downloadFileUrl} from '@/utils/method'
    import * as api from '@/api/advAnalys/advAnalys.js'
    import uploadInfo from './uploadInfo'
    import shipmentDetail from './shipmentDetail'
    import personInChargeModal from './personInChargeModal'

    export default {
        data() {
            return {
                tableHeight: null,
                addSubLibraryModal: false,
                query: {
                    filename: '',
                    remark: '',
                    page: 1,
                    limit: 20
                },
                list: [],
                total: 0,
                loading: true,
                authList: [],
                defaultProps: {
                    children: 'children',
                    label: 'title'
                },
                authLoading: false,
                authFormVisible: false,
                authFormData: {
                    role_id: '',
                    auth_rules: []
                },
                authDefaultCheckedKeys: [],
                index: null,
                formName: null,
                formMap: {
                    add: '新增角色',
                    edit: '编辑'
                },
                formLoading: false,
                formVisible: false,
                formRules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'}
                    ],
                    status: [
                        {required: true, message: '请选择状态', trigger: 'change'}
                    ]
                },
                deleteLoading: false
            }
        },
        computed: {
            showAsinSupervisor() {
                return this.$checkPermission('logistics_asin_supervisor')
            },
        },
        components: {uploadInfo, shipmentDetail, personInChargeModal},
        methods: {
            handleDetail(index,data) {
                this.$refs.shipmentDetailRef.showModal(data)
            },
            // 关闭弹窗回调
            closeCllback(isShow) {
                this.addSubLibraryModal = false
                isShow == true && this.getList()
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            onReset() {
                this.query = {
                    filename: '',
                    remark: '',
                    page: 1,
                    limit: 20
                }
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            personInCharge(){
                this.$refs.personInChargeModal.showModal()
            },
            uploadFunc() {
                this.addSubLibraryModal = true
            },
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                api.logistics_index_index(this.query)
                    .then(response => {
                        this.loading = false
                        this.list = response.data.list || []
                        this.total = response.data.total || 0
                    })
                    .catch(() => {
                        this.loading = false
                        this.list = []
                        this.total = 0
                    })
            },
        },
        mounted() {
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            140 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
        },
        created() {
            // 加载表格数据
            this.getList()
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ ::-webkit-scrollbar {
        width: 7px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ ::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ ::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ ::-webkit-scrollbar-thumb:horizontal {
        width: 7px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
</style>
